import styled from "@emotion/styled";
import MuiDrawer from "@mui/material/Drawer";

// Drawer is the custom drawer AKA Side Navigation panel
export const Drawer = ({ open, variant, drawerWidth, children }) => {
  // Create the custom drawer component by added custom styles
  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    "& .MuiDrawer-paper": {
      position: "relative",
      whiteSpace: "nowrap",
      width: drawerWidth,
      border: "0px",
      backgroundColor: "#FFF",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // boxSizing: "border-box",
      marginLeft: 0,
      ...(!open && {
        overflowX: "hidden",
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        display: "none",
      }),
    },
  }));

  return (
    <Drawer
      open={open}
      variant={variant}
      sx={{
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
        },
      }}
    >
      {children}
    </Drawer>
  );
};
